<p>
  login works!
</p>
<button (click)="login()">Login</button>
